import React, { useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { MdOutlineCreateNewFolder } from "react-icons/md";
import { FaLeaf } from "react-icons/fa";

function CreatedOn() {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedOption, setSelectedOption] = useState('')

  const handleOptionClick = (option) => {
    console.log("Selected:", option);
    setSelectedOption(option)
    setIsOpen(false);
  };

  const options = [
    "Bulk Edit",
    "Status",
    "Export",
    "Assigned to",
    "Add Tags",
    "Email",
    "SMS",
    "Contacts",
    "Delete",
  ];

  const filteredOptions = options.filter((opt) =>
    opt.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="relative">
      <div
        className="group relative cursor-pointer inline-block "
        onMouseLeave={() => setIsOpen(false)}
      >
        <div
          data-tooltip-id="main-tooltip"
          data-tooltip-content="Created On"
          className="text-sm bg-gray-200 text-gray-500 shadow-sm font-semibold rounded-md px-3 py-1.5 flex gap-1 items-center justify-center hover:text-gray-800 transition-all"
          onClick={() => setIsOpen(!isOpen)}
        >
          <MdOutlineCreateNewFolder size={18} />
          {selectedOption || 'Created On'}
        </div>

        {isOpen && (
          <div
            className="absolute z-50 mt-2 border right-0 w-40 origin-top-left  rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
            onMouseLeave={() => setIsOpen(false)}
          >
            <div className="px-2 pt-2 text-sm text-gray-700">
              <input
                type="text"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full text-sm mb-1 px-3 py-1 bg-white text-gray-700 font-medium rounded border border-gray-300 placeholder-gray-400 focus:outline-none"
              />
              {filteredOptions.map((option, idx) => (
                <div
                  key={idx}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleOptionClick(option)}
                >
                  {option}
                </div>
              ))}
              {filteredOptions.length === 0 && (
                <div className="px-4 py-2 text-gray-400">No match found</div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Tooltip */}
      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-5 !py-[2px] !text-white z-20 shadow-md"
      />
    </div>
  );
}

export default CreatedOn;
